import '@babel/polyfill';
import React from 'react';

import { Router } from 'react-router';
import { bootstrap } from 'circe/actions';
import { renderRoutes } from 'react-router-config';
import { connect } from 'react-redux';
import { tokens } from 'circe/authentication/actions';
import { authorizedCallback } from 'domain/fuse/payments/actions';
import LoadingIndicator from 'domain/layout/components/LoadingIndicator';
import history from './store/history';
import routes from './routes';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import { isBlocked as isUiBlocked } from 'domain/layout/selectors';
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import * as amplitude from '@amplitude/analytics-browser';

const AMPLITUDE_KEY = '3603077c2d70e3e0bcd4513806239481';

if (ENV === 'production') {
  amplitude.init(AMPLITUDE_KEY);
}

const growthbook = new GrowthBook({
  // Callback when a user is put into an A/B experiment
  trackingCallback: (experiment, result) => {
    console.log('Experiment Viewed', {
      experimentId: experiment.key,
      variationId: result.variationId,
    });
  },
});

const urlParams = new URLSearchParams(window.location.search);

class App extends React.Component {
  componentDidMount() {
    this.props.doBootstrap();
    fetch(`https://cdn.growthbook.io/api/features/${GROWTH_BOOK_API_KEY}`)
      .then((res) => res.json())
      .then((parsed) => {
        growthbook.setFeatures(parsed.features);
      });
  }
  componentDidUpdate(prevProps) {
    const { userData, profile } = this.props;
    const { given_name, family_name, email } = userData || {};
    const { profileId, accountInfo, role, domain, accountId } = profile || {};
    if (profileId) {
      const { name: accountName, accountType } = accountInfo || {};
      amplitude.setUserId(email);
      const identifyObj = new amplitude.Identify();

      identifyObj.set('email', email);
      identifyObj.set('firstName', given_name);
      identifyObj.set('lastName', family_name);
      identifyObj.set('account', accountName);
      identifyObj.set('accountType', accountType);
      identifyObj.set('role', role);
      identifyObj.set('profileId', profileId);
      identifyObj.set('domain', domain);
      identifyObj.set('accountId', accountId);
      amplitude.identify(identifyObj);
    }
  }

  render() {
    const {
      userData = {
        anonymous_email: '',
      },
      isLoading,
    } = this.props;

    if (isLoading) {
      return <LoadingIndicator />;
    }

    return (
      <>
        <GrowthBookProvider growthbook={growthbook}>
          <Router history={history}>{renderRoutes(routes)}</Router>
        </GrowthBookProvider>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.circe.authentication.userData,
  isLogged: state.circe.authentication.logged,
  isLoading: isUiBlocked(state),
  profile: state?.app?.auth?.profile,
});
const mapDispatchToProps = (dispatch) => ({
  doBootstrap: () => dispatch(bootstrap()),
  updateTokens: (tknz) => dispatch(tokens(tknz)),
  authorizedDone: (response, message, merchantReference) => {
    dispatch(authorizedCallback(response, message, merchantReference));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
